import React, { useEffect, useState } from "react";


function UserInfo({ formData, setFormData  }) {
  const [eventdata, setData] = useState(null);
  const [hasRequested, setHasRequested] = useState(false);
  
     
    

  return (
    <div className="personal-info-container">
      <input
        type="text"
        placeholder="First Name..."
        value={formData.firstName}
        onChange={(e) => {
          setFormData({ ...formData, firstName: e.target.value });
        }}
        required // Make this field required
      />
      <input
        type="text"
        placeholder="Last Name..."
        value={formData.lastName}
        onChange={(e) => {
          setFormData({ ...formData, lastName: e.target.value });
        }}
        required // Make this field required
      />
      <input
        type="text"
        placeholder="State..."
        value={formData.state}
        onChange={(e) => {
          setFormData({ ...formData, state: e.target.value });
        }}
        required // Make this field required
      />
         <input
        type="text"
        placeholder="City..."
        value={formData.city}
        onChange={(e) => {
          setFormData({ ...formData, city: e.target.value });
        }}
        required // Make this field required
      />
        <input
        type="text"
        placeholder="Email..."
        value={formData.email}
        onChange={(e) => {
          setFormData({ ...formData, email: e.target.value });
        }}
        required // Make this field required
      />
        <input
        type="text"
        placeholder="Phone..."
        value={formData.phoneNumber}
        onChange={(e) => {
          setFormData({ ...formData, phoneNumber: e.target.value });
        }}
        required // Make this field required
      />
    </div>
  );
}

export default UserInfo;
